import { createStore } from "vuex";
import axios           from "axios";

axios.defaults.headers.common = {
    'X-Requested-With' : 'XMLHttpRequest',
    'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
};

let state =
        {
            ready       : false,
            form        : {},
            actions     : [],
            datastore   : [],
            currentGroup: 0,
            totalGroup: 0

        };

let getters =
        {


        };


let actions =
        {
            async form ( { commit }, id)
            {
                let response = await axios.get(`/endpoints/form/${id}`);
                console.log('Form data received',response.data )
                commit("form", response.data);

            },

            async validate ( { commit, state }, data )
            {
                let id = state.form.id;

                let payload = {id, data}
                let response = await axios.post(`/endpoints/form/validate`, payload);

                return response.data;
            },

            async submit ( { commit, state }, data )
            {
                let id = state.form.id;

                let payload = {id, data}
                let response = await axios.post(`/endpoints/form/submit`, payload);

                commit("actions",response.data.actions);

                return response.data;
            }
        }


let mutations =
        {

            copydeck ( state, payload)
            {
                state.copydeck = payload;
            },

            form ( state, payload)
            {
                state.form = payload;

                state.currentGroup = 0;
                state.totalGroup = payload.data.groups.length;
            },


            currentGroup (state, payload)
            {
                state.currentGroup = payload;
            },

            incrementCurrentGroup (state)
            {
                state.currentGroup++;
            },


            datastore (state, payload)
            {
                for (let i = 0; i < payload.length; i++)
                {
                    let field = payload[i];
                    let index = state.datastore.findIndex ( f => f.field === field.field);

                    if (index > -1)
                    {
                        state.datastore[index].value = field.value;
                    }
                    else
                    {
                        state.datastore.push(field);
                    }
                }
            },

            ready ( state )
            {
                state.ready = true;
            },

            actions ( state, payload)
            {
                state.actions = payload;
            }


        }


export default createStore( { state, getters, actions, mutations } );

